import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core'
import { LandingPagesService } from '../../landing-pages.service'

@Component({
  standalone: false,

  selector: 'vs-featured-products',
  templateUrl: './featured-products.component.html',
  styleUrls: ['./featured-products.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FeaturedProductsComponent implements OnInit {
  featuresProducts: any = {
    MASO_SVI3: 'Masoneilan SVI3',
  }
  carouselData: any = {
    autoRotateTime: 12,
    carouselItem: [],
  }

  constructor(
    private landingPagesService: LandingPagesService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.fetchBannerDetails()
  }

  buttonClicked(urlLink) {
    window.open(urlLink, '_blank')
  }

  fetchBannerDetails() {
    this.landingPagesService.fetchCarouselBannerDetails().subscribe(
      (data) => {
        if (
          data !== null &&
          data !== undefined &&
          data['banners'] !== undefined
        ) {
          this.carouselData.carouselItem = data['banners']
          this.landingPagesService.preLoadImages.next(true)
        } else {
          this.carouselData.carouselItem = []
        }
      },
      (err) => {
        this.carouselData.carouselItem = []
      }
    )
  }
}
